<app-dialog-layout class="callback-dialog">
  <ng-container content>
    <cpb-form-renderer [showHeader]="false" [formKey]="formKey" [context]="{ lead_id: leadId }"> </cpb-form-renderer>
  </ng-container>

  <ng-container buttons>
    <cap-button styleClass="primary" [label]="'button.submit' | translate" (onClick)="submit()"></cap-button>
  </ng-container>
</app-dialog-layout>
